import React from 'react'
import PropTypes from 'prop-types'
import { Box, Flex, Check, Button } from '@elparking/components'
import Features from './Features'
import Recommended from './Recommended'
import PriceBlock from './PriceBlock'
import { FormattedMessage } from 'react-intl'

const ShortFeatureSelection = ({
    carId,
    rate,
    highlighted,
    setSelected,
    selected,
    onClick,
}) => {
    return <Box as='label' htmlFor={`rates_mobile_${carId}_${rate.id}`}>
        <Flex width='100%' justifyContent='space-between' textAlign='left'>
            <Flex w='100%' textAlign='left'
              alignItems='flex-start'
              justifyContent='strech'
              flexDirection='column'>
                <Box display='block' mt='10px' mb='5px'>
                    <Check
                      name={`rates_mobile_${carId}`}
                      id={`rates_mobile_${carId}_${rate.id}`}
                      data-test={`rate_mobile_${carId}_${rate.id}`}
                      fontSize='large'
                      fontWeight='bold'
                      fontColor='accent_dark'
                      label={rate.name}
                      type='checkbox'
                      value={rate.id}
                      justifyContent='start'
                      checked={selected}
                      onChange={({ target }) => setSelected(selected ? '' : target.value)} textAlign='left' />
                </Box>
                <Box display='block' mb='10px'>
                    {highlighted && <Recommended backgroundColor='accent10'/>}
                </Box>
            </Flex>
            <Box mt='10px'>
                <PriceBlock
                  rate={rate}
                  flexDirection='row'
                  textAlign='right'
                />
            </Box>
        </Flex>
        {selected && <Box w='100%'>
            <Features display='block' features={rate.features} />
            <Box w='100%' mt='20px' mb='20px'>
                <Button width='100%' fontSize='small' height='auto' dataTest={`select-rate-button-${carId}-${rate.id}`} fontWeight='book' onClick={() => onClick(rate)}>
                    <FormattedMessage defaultMessage='Seleccionar' />
                </Button>
            </Box>
        </Box>}
    </Box>
}

ShortFeatureSelection.propTypes = {
    highlighted: PropTypes.bool,
    setSelected: PropTypes.func,
    selected: PropTypes.any,
    rate: PropTypes.shape({
        id: PropTypes.any,
        name: PropTypes.any,
        features: PropTypes.array,
    }),
    carId: PropTypes.any,
    features: PropTypes.array,
    onClick: PropTypes.func,
}

export default ShortFeatureSelection
